import { type NodeModel, type DropOptions } from '@minoru/react-dnd-treeview'
import type { Inbox } from 'entities/Inbox/model/Inbox'
import type { UnifiedInbox } from 'entities/Inbox/model/UnifiedInbox'
import type { GroupInbox } from 'entities/Inbox/model/GroupInbox'
import { type SmartView } from 'entities/SmartViews/model/SmartView'

export type IInboxCombine = Inbox | UnifiedInbox | GroupInbox
export type IInboxTreeCombine = Inbox | UnifiedInbox | GroupInbox | SmartView
export type IInboxKey = 'unified' | 'group' | 'shared' | 'smart_view'

export interface INodeModel<T> extends NodeModel<T> {
  groupInbox?: IInboxTreeCombine
}

export interface IDropOptions<T> extends DropOptions<T> {
  groupInbox?: Inbox
}

export enum TreeRootInboxes {
  FAVORITE = 'favorite',
  SIMPLE = 'simple',
  SMART = 'smart',
  SMART_VIEW = 'smart_view',
}

export type InboxType = 'inbox_group' | 'inbox' | 'unified-inbox' | 'smart_view-inbox'

export type IBaseInbox = {
  id: number
  name?: string
  is_favorite: boolean
}
